export default __webpack_public_path__ + "static/media/black-redo-measure-icon.8d90f253.svg";